module.exports = function ($httpProvider, $provide) {
    $provide.factory('http401Interceptor', [
        '$q', '$injector', '$window', 'LoadingIndicatorService',
        function ($q, $injector, $window, loadingIndicator) {
            return {
                responseError(rejection) {
                    if (rejection.status === 401) {
                        const loginService = $injector.get('LoginService');
                        loadingIndicator.finishLoading();

                        loginService.promptForLogin(loginService.LoginToContinueMessage);
                    }
                    const $state = $injector.get('$state');
                    if (rejection.status === 404) {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                    if (rejection.status === 500) {
                        $state.go('error.500');
                    }
                    if (rejection.status === 403) {
                        $state.go('error.403');
                    }

                    return $q.reject(rejection);
                },
            };
        },
    ]);

    $provide.factory('http200Interceptor', [
        '$rootScope', function ($rootScope) {
            return {
                response(response) {
                    if (response.status === 200) {
                        // Reset the reservation timer
                        $rootScope.$broadcast('http:success');
                    }

                    return response;
                },
            };
        },
    ]);

    $httpProvider.interceptors.push('http401Interceptor');
    $httpProvider.interceptors.push('http200Interceptor');
};



// WEBPACK FOOTER //
// ./src/configuration/http.js